// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-control.ant-select.ant-select-enabled,.form-control.ant-select.ant-select-disabled{padding:0}.form-control>.ant-select-selection{height:100%}.form-control .ant-select-selection__rendered{height:100%;display:flex;align-items:center}", ""]);
// Exports
module.exports = exports;
